import { Box, GridProps, Stack, useTheme } from '@mui/material';
import { ArrowRight } from '@portals/icons/src/ArrowRight/ArrowRight';
import React from 'react';

import type { Theme } from '../../themes/themes';
import { Typography } from '../Typography/Typography';
import { getStyles } from './ServiceLink.styles';

interface ServiceLinkProps {
  children: React.ReactNode;

  icon?: React.ReactNode;
  description?: string;

  component?: 'div' | 'button' | 'a';
  href?: HTMLAnchorElement['href'];
  target?: HTMLAnchorElement['target'];
  rel?: HTMLAnchorElement['rel'];
  onClick?: GridProps['onClick'];
}

export const ServiceLink: React.FC<ServiceLinkProps> = ({
  description,
  icon,
  children,
  ...props
}: ServiceLinkProps) => {
  const theme = useTheme<Theme>();
  const styles = getStyles(theme);

  return (
    <Stack {...props}>
      <Box sx={styles.box}>
        {icon && <Box sx={styles.icon}>{icon}</Box>}
        <Box sx={styles.text}>
          {children}
          <ArrowRight sx={styles.arrowIcon} />
        </Box>
      </Box>

      {description ? (
        <Box sx={styles.description}>
          <Typography variant="body2">{description}</Typography>
        </Box>
      ) : null}
    </Stack>
  );
};
